export default __webpack_public_path__ + "static/media/silver-heart-shape.dd14f409.svg";